import React from 'react';

import LanguageProvider from 'helpers/localization/languageProvider';
import ReactDOM from 'react-dom';
import { Toaster } from 'react-hot-toast';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import './i18n';
import * as serviceWorker from './serviceWorker';
import store from './store';

// Version-skew self-healing: after a deploy the old hashed lazy chunks no longer exist,
// so a client on a stale index.html gets a ChunkLoadError (Safari: "Importing a module
// script failed") and sees blank sections (e.g. an empty sidebar). Reload once to pick up
// the fresh build; the sessionStorage guard prevents a reload loop if the network is down.
const isStaleChunkError = (msg) =>
  /Loading (CSS )?chunk [\d]+ failed|ChunkLoadError|Importing a module script failed|error loading dynamically imported module/i.test(
    String(msg || '')
  );

const reloadOnceForFreshBuild = () => {
  try {
    if (sessionStorage.getItem('chunk_reload') === '1') return;
    sessionStorage.setItem('chunk_reload', '1');
  } catch (e) {
    /* storage unavailable — still reload */
  }
  window.location.reload();
};

window.addEventListener('error', (e) => {
  if (isStaleChunkError(e?.message)) reloadOnceForFreshBuild();
});
window.addEventListener('unhandledrejection', (e) => {
  if (isStaleChunkError(e?.reason?.message || e?.reason)) reloadOnceForFreshBuild();
});

const app = (
  <LanguageProvider>
    <Provider store={store}>
      <BrowserRouter>
        <App />
        <Toaster position="top-right" />
      </BrowserRouter>
    </Provider>
  </LanguageProvider>
);

ReactDOM.render(app, document.getElementById('root'));
serviceWorker.unregister();
